import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Tabs,
  Tab,
  Box,
  TextField,
} from "@mui/material";
import EditText from "../../components/editText";
import AddFaq from "../../Modals/addFaq";
import AddExpertise from "../../Modals/addExpertise";
import AddGroup from "../../Modals/addGroup";
import AddInterest from "../../Modals/addinterest";
import * as Yup from "yup";
import { useFormik } from "formik";
import { showError, showToast } from "../../constants/toasts";
import {
  useAddAboutUsMutation,
  useAddCancellationMutation,
  useAddContactSupportMutation,
  useAddLegalMutation,
  useAddPrivacyPolicyMutation,
  useLazyDeleteExpertiseQuery,
  useLazyDeleteFaqQuery,
  useLazyDeleteInterestQuery,
  useLazyGetAboutUsQuery,
  useLazyGetCancellationQuery,
  useLazyGetContactSupportQuery,
  useLazyGetExpertiseQuery,
  useLazyGetFaqQuery,
  useLazyGetInterestQuery,
  useLazyGetLegalQuery,
  useLazyGetPrivacyPolicyQuery,
} from "../../service/cms";
import { FaqRes } from "../../types/General";
import useAuth from "../../hooks/useAuth";
import dayjs from "dayjs";
import { isValidInput } from "../../utils/validations";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import Loader from "../../constants/Loader";
import { formatDubaiDateTime } from "../../utils/dateTime";
import PhoneInput from "react-phone-input-2";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface CmsFormValues {
  email: string;
  phone: string;
  countryDialCode: string;
}

interface Interests {
  created: string;
  id: number;
  isActive: boolean;
  name: string;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCms = () => {
  const navigate = useNavigate();
  const userData = useAuth();
  const [searchParams] = useSearchParams();
  const [getContact] = useLazyGetContactSupportQuery();
  const [getLegal] = useLazyGetLegalQuery();
  const [policy] = useLazyGetPrivacyPolicyQuery();
  const [updateContact] = useAddContactSupportMutation();
  const [updateLegal] = useAddLegalMutation();
  const [updatePrivacy] = useAddPrivacyPolicyMutation();
  const [updateAbout] = useAddAboutUsMutation();
  const [updateCancellation] = useAddCancellationMutation();
  const [getFaqsList] = useLazyGetFaqQuery();
  const [deleteFaq] = useLazyDeleteFaqQuery();
  const [getInterest] = useLazyGetInterestQuery();
  const [deleteInterest] = useLazyDeleteInterestQuery();
  const [getExpertise] = useLazyGetExpertiseQuery();
  const [deleteExpertise] = useLazyDeleteExpertiseQuery();
  const [about] = useLazyGetAboutUsQuery();
  const [cancellation] = useLazyGetCancellationQuery();

  // existing tab state
  const [valueTabs, setValueTabs] = useState(
    Number(searchParams.get("tab")) || 0
  );

  useEffect(() => {
    const tab = Number(searchParams.get("tab")) || 0;
    setValueTabs(tab);
  }, [searchParams]);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setPage(1);
    setValueTabs(newValue);
    navigate(`/manage-cms?tab=${newValue}`);
  };

  const [openModal, setOpenModal] = useState(false);
  const [openModal1, setOpenModal1] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openModal3, setOpenModal3] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedInterest, setSelectedInterest] = useState(0);
  const [selectedExpertise, setSelectedExpertise] = useState("");
  const [selectedFaq, setSelectedFaq] = useState<FaqRes | null>(null);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [countryCode, setCountryCode] = useState("+971");
  const [isEdit, setIsEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");

  const [faq, setFaq] = useState<any>([]);
  const [interests, setInterests] = useState<Interests[]>([]);
  const [expertise, setExpertise] = useState([]);
  const [count, setCount] = useState(0);
  const [submitted, setSubmitted] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      phone: "",
      countryDialCode: "+971",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .test(
          "no-whitespace",
          "Email cannot be only spaces",
          (value: string | undefined) => !!value && value.trim().length > 0
        )
        .matches(
          /^(([^<>()[\].,;:\s@\"]+(\.[^<>()[\].,;:\s@\"]+)*)|(".+"))@(([^<>()[\].,;:\s@\"]+\.)+[^<>()[\].,;:\s@\"]{2,})$/i,
          "Enter a valid email address"
        ),
      phone: Yup.string()
        .required("Phone number is required")
        .test(
          "no-whitespace",
          "Phone cannot be only spaces",
          (value: string | undefined) => !!value && value.trim().length > 0
        )
        .min(6, "Phone number must be at least 6 characters")
        .max(16, "Phone number must be at most 16 characters"),
    }),
    onSubmit: async (values: CmsFormValues) => {
      try {
        setLoading(true);
        const body = {
          email: values.email,
          phoneNumber: values.phone,
          countryDialCode: values.countryDialCode,
        };

        const contactResponse = await updateContact(body).unwrap();
        setLoading(false);
        if (contactResponse.status === 200) {
          showToast("CMS updated successfully!");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message);
      }
    },
  });

  const formik1 = useFormik({
    enableReinitialize: true,
    initialValues: {
      legal: "",
    },
    validationSchema: Yup.object({
      legal: Yup.string()
        .required("Legal is required")
        .test(
          "no-whitespace",
          "Terms & Conditions cannot be only spaces",
          (value: string | undefined) => !!value && value.trim().length > 0
        ),
    }),
    onSubmit: async (values: { legal: string }) => {
      try {
        setLoading(true);
        const body = {
          content: values.legal,
        };

        const contactResponse = await updateLegal(body).unwrap();
        setLoading(false);
        if (contactResponse.status === 200) {
          showToast("CMS updated successfully!");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message);
      }
    },
  });

  const formik2 = useFormik({
    enableReinitialize: true,
    initialValues: {
      privacyPolicy: "",
    },
    validationSchema: Yup.object({
      privacyPolicy: Yup.string()
        .required("Privacy Policy is required")
        .test(
          "no-whitespace",
          "Privacy Policy cannot be only spaces",
          (value: string | undefined) => !!value && value.trim().length > 0
        ),
    }),
    onSubmit: async (values: { privacyPolicy: string }) => {
      try {
        setLoading(true);
        const body = {
          content: values.privacyPolicy,
        };

        const contactResponse = await updatePrivacy(body).unwrap();
        setLoading(false);
        if (contactResponse.status === 200) {
          showToast("CMS updated successfully!");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message);
      }
    },
  });

  const formik3 = useFormik({
    enableReinitialize: true,
    initialValues: {
      about: "",
    },
    validationSchema: Yup.object({
      about: Yup.string()
        .required("About Us is required")
        .test(
          "no-whitespace",
          "About Us cannot be only spaces",
          (value: string | undefined) => !!value && value.trim().length > 0
        ),
    }),
    onSubmit: async (values: { about: string }) => {
      try {
        setLoading(true);
        const body = {
          content: values.about,
        };

        const contactResponse = await updateAbout(body).unwrap();
        setLoading(false);
        if (contactResponse.status === 200) {
          showToast("CMS updated successfully!");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message);
      }
    },
  });

  const formik4 = useFormik({
    enableReinitialize: true,
    initialValues: {
      cancellation: "",
    },
    validationSchema: Yup.object({
      cancellation: Yup.string()
        .required("Cancellation Policy is required")
        .test(
          "no-whitespace",
          "Cancellation Policy cannot be only spaces",
          (value: string | undefined) => !!value && value.trim().length > 0
        ),
    }),
    onSubmit: async (values: { cancellation: string }) => {
      try {
        setLoading(true);
        const body = {
          content: values.cancellation,
        };

        const contactResponse = await updateCancellation(body).unwrap();
        setLoading(false);
        if (contactResponse.status === 200) {
          showToast("CMS updated successfully!");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message);
      }
    },
  });

  const getContactSupport = async () => {
    setLoading(true);
    try {
      const response = await getContact({}).unwrap();
      setLoading(false);
      if (response.status === 200) {
        formik.setFieldValue("email", response?.data?.contactDetails?.email);
        formik.setFieldValue(
          "phone",
          response?.data?.contactDetails?.phoneNumber?.phoneNumber
        );
        formik.setFieldValue(
          "countryDialCode",
          response?.data?.contactDetails?.phoneNumber?.countryDialCode
        );
        // setCountryCode(response?.data?.dialCode || "+91");
        // setPhoneDisplay(
        //   (response?.data?.dialCode || "") + (response?.data?.phone || "")
        // );
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getLegalSupport = async () => {
    setLoading(true);
    try {
      const response = await getLegal({}).unwrap();
      setLoading(false);
      if (response.status === 200) {
        formik1.setFieldValue("legal", response?.data?.legalContent);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getPrivacyPolicy = async () => {
    setLoading(true);
    try {
      const response = await policy({}).unwrap();
      setLoading(false);
      if (response.status === 200) {
        formik2.setFieldValue("privacyPolicy", response?.data?.privacyContent);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getAboutUs = async () => {
    setLoading(true);
    try {
      const response = await about({}).unwrap();
      setLoading(false);
      if (response.status === 200) {
        formik3.setFieldValue("about", response?.data?.content);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getCancellation = async () => {
    setLoading(true);
    try {
      const response = await cancellation({}).unwrap();
      setLoading(false);
      if (response.status === 200) {
        formik4.setFieldValue("cancellation", response?.data?.content);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  // const getCmsData = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await getCms({}).unwrap();
  //     setLoading(false);
  //     if (response.status === 200) {
  //       formik.setValues({
  //         email: response.data?.email || "",
  //         phone: response?.data?.phone || "",
  //         aboutUs: response?.data?.aboutUs || "",
  //         privacyPolicy: response?.data?.privacyPolicy || "",
  //         dataDeletionPolicy: response?.data?.dataDeletionPolicy || "",
  //         terms: response?.data?.terms || "",
  //       });
  //       setPhoneCode(response?.data?.dialCode || "+91");
  //       setPhoneDisplay(
  //         (response?.data?.dialCode || "") + (response?.data?.phone || "")
  //       );
  //     }
  //   } catch (error: any) {
  //     setLoading(false);
  //     showError(error?.data?.message || "");
  //   }
  // };

  const handleSaveLegal = async () => {
    await formik1.setTouched({ legal: true });
    await formik1.validateForm();
    const { legal } = formik1.errors;
    if (legal) {
      showError("Please enter valid values for Legal field.");
      return;
    }
    formik1.handleSubmit();
  };

  const handleSavePrivacy = async () => {
    await formik2.setTouched({ privacyPolicy: true });
    await formik2.validateForm();
    const { privacyPolicy } = formik2.errors;
    if (privacyPolicy) {
      showError("Please enter valid values for Privacy Policy field.");
      return;
    }
    formik2.handleSubmit();
  };

  const handleSaveAbout = async () => {
    await formik3.setTouched({ about: true });
    await formik3.validateForm();
    const { about } = formik3.errors;
    if (about) {
      showError("Please enter valid values for Privacy Policy field.");
      return;
    }
    formik3.handleSubmit();
  };

  const handleSaveCancellation = async () => {
    await formik4.setTouched({ cancellation: true });
    await formik4.validateForm();
    const { cancellation } = formik4.errors;
    if (cancellation) {
      showError("Please enter valid values for Privacy Policy field.");
      return;
    }
    formik4.handleSubmit();
  };

  const handleSaveContact = async () => {
    setSubmitted(true);
    await formik.setTouched({ email: true, phone: true });
    await formik.validateForm();
    const { email, phone } = formik.errors;
    if (email || phone) {
      showError("Please enter valid values for Contact fields.");
      return;
    }
    formik.handleSubmit();
  };

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phoneNumber", phone?.replace(country.dialCode, ""));
    formik.setFieldValue("countryDialCode", country?.dialCode);
  };

  const getFaqList: any = async () => {
    setLoading(true);
    try {
      const response = await getFaqsList({
        page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setFaq(response?.data || []);
        // setCount(response?.data?.totalCount || 0);
      } else {
        setLoading(false);
        setFaq([]);
        setCount(0);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const handleDelete = async () => {
    try {
      const response = await deleteFaq({ id: selectedId }).unwrap();
      setLoading(false);
      if (response?.status === 200) {
        showToast("Faq Deleted successfully");
        getFaqList();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleInterestDelete = async () => {
    try {
      const response = await deleteInterest({ id: selectedInterest }).unwrap();
      setLoading(false);
      if (response?.status === 200) {
        showToast("Interest Deleted successfully");
        getInterestApi();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleDeleteExpertise = async () => {
    try {
      const response = await deleteExpertise({
        id: selectedExpertise,
      }).unwrap();
      setLoading(false);
      if (response?.status === 200) {
        showToast("Expertise Deleted successfully");
        getExpertiseApi();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const getInterestApi: any = async () => {
    setLoading(true);
    try {
      const response = await getInterest({
        page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setInterests(response?.data || []);
        // setCount(response?.data?.totalCount || 0);
      } else {
        setLoading(false);
        setInterests([]);
        setCount(0);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getExpertiseApi: any = async () => {
    setLoading(true);
    try {
      const response = await getExpertise({
        page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      if (response?.status === 200) {
        setLoading(false);
        setExpertise(response?.data?.items || []);
        // setCount(response?.data?.totalCount || 0);
      } else {
        setLoading(false);
        setInterests([]);
        setCount(0);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getContactSupport();
    getLegalSupport();
    getPrivacyPolicy();
    getExpertiseApi();
    getAboutUs();
    getCancellation();
  }, []);

  useEffect(() => {
    if (valueTabs === 5) {
      getFaqList();
    } else if (valueTabs === 6) {
      getExpertiseApi();
    } else if (valueTabs === 7) {
      getInterestApi();
    }
  }, [page, debouncedSearchTerm, valueTabs]);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title">
        <h1>Manage CMS</h1>
        <p>
          <span
            role="button"
            tabIndex={0}
            onClick={() => navigate("/dashboard")}
          >
            Dashboard
          </span>{" "}
          - Manage CMS
        </p>
      </div>

      <div className="table_header">
        <div className="left_s">
          <Box className="custom_tabs1" sx={{ width: "100%" }}>
            <Tabs
              value={valueTabs}
              onChange={handleChangeTabs}
              aria-label="basic tabs example"
              className="custom_tabs_links"
            >
              <Tab label="Contact Support" {...a11yProps(0)} />
              <Tab label="Terms & Conditions" {...a11yProps(1)} />
              <Tab label="Privacy Policy" {...a11yProps(2)} />
              <Tab label="About Us" {...a11yProps(3)} />
              <Tab label="Cancellation Policy" {...a11yProps(4)} />

              <Tab label="FAQ" {...a11yProps(5)} />
              <Tab label="Expertise" {...a11yProps(6)} />
              <Tab label="Interests" {...a11yProps(7)} />
            </Tabs>
          </Box>
        </div>
      </div>

      <div className="cards">
        <CustomTabPanel value={valueTabs} index={0}>
          <form className="form" onSubmit={formik.handleSubmit}>
            <div className="gap_p">
              <div className="control_group w_50">
                <label htmlFor="email">Email Address</label>
                <TextField
                  variant="outlined"
                  placeholder="Enter here"
                  id="email"
                  name="email"
                  fullWidth
                  hiddenLabel
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  helperText={formik.touched.email && formik.errors.email}
                  className="text_field"
                />
              </div>
              <div className="control_group w_50">
                <label>Phone Number</label>
                <PhoneInput
                  enableSearch
                  value={formik.values.countryDialCode + formik.values.phone}
                  country={"uae"}
                  inputClass="phoneInput"
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  inputStyle={{ width: "100%", backgroundColor: "#232323" }}
                  buttonClass="phoneBtn"
                  placeholder="Phone Number"
                />
                <p className="err_msg">
                  {submitted && !formik.values.phone?.length
                    ? "Phone number is required"
                    : ""}
                </p>
              </div>
            </div>
          </form>
          <div className="form_btn">
            <Button className="btn btn_primary" onClick={handleSaveContact}>
              Save
            </Button>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={1}>
          <EditText
            content={formik1.values.legal}
            setContent={(content: string) =>
              formik1.setFieldValue("legal", content)
            }
          />

          {formik1.touched.legal && formik1.errors.legal && (
            <h6 className="err_msg">{formik1.errors.legal}</h6>
          )}
          <div className="form_btn">
            <Button className="btn btn_primary" onClick={handleSaveLegal}>
              Save
            </Button>
          </div>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={2}>
          <EditText
            content={formik2.values.privacyPolicy}
            setContent={(content: string) =>
              formik2.setFieldValue("privacyPolicy", content)
            }
          />

          {formik2.touched.privacyPolicy && formik2.errors.privacyPolicy && (
            <h6 className="err_msg">{formik2.errors.privacyPolicy}</h6>
          )}
          <div className="form_btn">
            <Button className="btn btn_primary" onClick={handleSavePrivacy}>
              Save
            </Button>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={3}>
          <EditText
            content={formik3.values.about}
            setContent={(content: string) =>
              formik3.setFieldValue("about", content)
            }
          />

          {formik3.touched.about && formik3.errors.about && (
            <h6 className="err_msg">{formik3.errors.about}</h6>
          )}
          <div className="form_btn">
            <Button className="btn btn_primary" onClick={handleSaveAbout}>
              Save
            </Button>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={4}>
          <EditText
            content={formik4.values.cancellation}
            setContent={(content: string) =>
              formik4.setFieldValue("cancellation", content)
            }
          />

          {formik4.touched.cancellation && formik4.errors.cancellation && (
            <h6 className="err_msg">{formik4.errors.cancellation}</h6>
          )}
          <div className="form_btn">
            <Button
              className="btn btn_primary"
              onClick={handleSaveCancellation}
            >
              Save
            </Button>
          </div>
        </CustomTabPanel>

        <CustomTabPanel value={valueTabs} index={5}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                placeholder="Search...."
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setIsEdit(false);
                  setOpenModal(true);
                  setSelectedFaq(null);
                  setSelectedId("");
                }}
              >
                Add FAQ
              </Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr.no</TableCell>
                  <TableCell sx={{ minWidth: 250 }}>Question</TableCell>
                  <TableCell>Answer</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {faq?.length ? (
                  faq?.map((row: any, i: number) => (
                    <TableRow key={row?.id}>
                      <TableCell>{(page - 1) * 10 + i + 1}</TableCell>
                      <TableCell>{row?.question || ""}</TableCell>
                      <TableCell className="max_c2">
                        <p>{row?.answer || ""}</p>
                      </TableCell>
                      <TableCell>
                        {dayjs(row?.date).format("DD MMM YYYY")}
                      </TableCell>
                      <TableCell>
                        <div className="table_actions v2">
                          <IconButton
                            onClick={() => {
                              setSelectedId(row?.id);
                              setSelectedFaq(row);
                              setOpenModal(true);
                            }}
                          >
                            <img src="/static/images/edit2_icon.svg" alt="" />
                          </IconButton>
                          <IconButton
                            onClick={() => {
                              setOpenDelete(true);
                              setSelectedId(row?.id);
                            }}
                          >
                            <img src="/static/images/trash2_icon.svg" alt="" />
                          </IconButton>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell align="center" colSpan={5}>
                      No data found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={6}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                placeholder="Search...."
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setIsEdit(false);
                  setOpenModal1(true);
                }}
              >
                Add Expertise
              </Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr.no</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {expertise?.map((row: any, i) => (
                  <TableRow>
                    <TableCell>{(page - 1) * 10 + i + 1}</TableCell>
                    <TableCell>{row?.name || "-"}</TableCell>
                    <TableCell>
                      {row?.createAt ? formatDubaiDateTime(row?.createAt) : "-"}
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() => {
                            setOpenDelete(true);
                            setSelectedExpertise(row?.id);
                          }}
                        >
                          <img
                            src="/static/images/trash2_icon.svg"
                            alt="Delete"
                          />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
        <CustomTabPanel value={valueTabs} index={7}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                placeholder="Search...."
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => {
                  setIsEdit(false);
                  setOpenModal3(true); // Consider renaming to setOpenInterestModal
                }}
              >
                Add Interest
              </Button>
            </div>
          </div>
          <TableContainer className="table_container">
            <Box className="heading"></Box>
            <Table sx={{ minWidth: 650 }} aria-label="interests table">
              <TableHead>
                <TableRow>
                  <TableCell>Sr.no</TableCell>
                  <TableCell> Title</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {interests?.map((row, i) => (
                  <TableRow>
                    <TableCell>{(page - 1) * 10 + i + 1}</TableCell>
                    <TableCell>{row?.name || "-"}</TableCell>
                    <TableCell>
                      {row?.created ? formatDubaiDateTime(row?.created) : "-"}
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton
                          onClick={() => {
                            setOpenDelete(true);
                            setSelectedInterest(row?.id);
                          }}
                        >
                          <img
                            src="/static/images/trash2_icon.svg"
                            alt="Delete"
                          />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
      </div>

      <AddFaq
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
        getFaqList={getFaqList}
        selectedId={selectedId}
        selectedFaq={selectedFaq}
      />
      <AddExpertise
        open={openModal1}
        onClose={handleCloseModal}
        setOpen={setOpenModal1}
        getExpertiseApi={getExpertiseApi}
      />
      <AddInterest
        open={openModal3}
        onClose={handleCloseModal}
        setOpen={setOpenModal3}
        getInterestApi={getInterestApi}
      />
      <AddGroup
        getGroupApi={() => {}}
        open={openModal2}
        onClose={handleCloseModal}
        setOpen={setOpenModal2}
      />
      <ConfirmationModal
        text={
          valueTabs === 5
            ? "Are you sure to delete this interest?"
            : valueTabs === 4
              ? "Are you sure to delete this Expertise?"
              : "Are you sure to delete this FAQ?"
        }
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={() => {
          valueTabs === 7
            ? handleInterestDelete()
            : valueTabs === 6
              ? handleDeleteExpertise()
              : handleDelete();
        }}
      />
    </MainContainer>
  );
};

export default ManageCms;
